import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import UserService from "./services/api/UserService";
import StoreService from "./services/api/StoreService";

// Create the React root node where the app will be mounted.
const root = ReactDOM.createRoot(document.getElementById("root"));

// Initialize the application store before rendering.
const store = StoreService.setup();

// Render the top-level App component and pass the initialized store as a prop.
root.render(
  <App store={store} />
);

// Initialize Keycloak authentication after the app is mounted.
// The callback receives the root and store so auth logic can interact with the rendered app state.
UserService.initKeycloak(() => root, store);

